<template>

  <div class="container">
    <el-row>
      <el-col :span="24" style="margin: 0 0 20px 20px;">




        <!-- 下拉选择判定状态 -->


        <el-row class="head-search">

          <el-col :span="24" style="margin: 10px 0;">
            <span class="title">状态:</span>
            <el-radio-group v-model="search_data.status" size="small">
              <el-radio label="" border>
                全部</el-radio>
              <el-radio label="1" border>
                启用</el-radio>
              <el-radio label="0" border>
                禁用</el-radio>
            </el-radio-group>
          </el-col>

        </el-row>




        <el-button type="primary" icon="el-icon-search" @click="searchLabelLists">搜索</el-button>
      </el-col>

    </el-row>




    <div v-for="(item, index) in tableData" style="margin-left: 20px;">

      <div v-for="(item2, index2) in item" style="margin-bottom: 10px;">

        <!-- 标题 -->
        <el-row>
          <el-col :span="24">
            <div class="title">
              <span></span>
              <h2>
                <a
                  style="width: 80px;display: inline-block; margin-right: 20px;">{{ index=="consumer"?'乘客端':index=="driver"?"司机端":"后台" }}</a>
                {{ item2.alias }}
              </h2>
            </div>
          </el-col>
        </el-row>

        <div v-for="(item3, index3) in item2.label" v-if="item2.type == 'star'" style="margin: 20px 0;">
          <el-rate v-model="star_point[(index3-1)]" disabled text-color="#ff9900">
          </el-rate>

          <el-tag closable v-for="(item4, index4) in item3" @close="handleClose(item4.label_code)"
            @click="toSwitch(item4.label_code,item4.status)" :type="item4.status=='1'?'':'info'">
            {{ item4.label }}
          </el-tag>


          <el-input class="input-new-tag" v-model="inputValue" v-if="inputVisible[(index3-1)].visible"
            ref="saveTagInput" size="small"
            @keyup.enter.native="((val)=>{handleInputConfirm(index,star_point[index3-1],index2)})"
            @blur="((val)=>{handleInputConfirm(index,star_point[(index3-1)],index2)})">
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput(index3)" round>添加标签</el-button>

        </div>


        <div style="padding: 10px 0;" v-if="item2.type == 'normal'">


          <el-tag closable v-for="(item3, index3) in item2.label" @close="handleClose(item3.label_code)"
            @click="toSwitch(item3.label_code,item3.status)" :type="item3.status=='1'?'':'info'">
            {{ item3.label }}

          </el-tag>

          <el-input class="input-new-tag" v-model="inputValue" v-if="input_adminVisible[index][index2]"
            ref="saveTagInput" size="small"
            @keyup.enter.native="((val)=>{handleInputConfirm(index,'1',index2)})"
            @blur="((val)=>{handleInputConfirm(index,'1',index2)})">
          </el-input>

          <el-button v-else class="button-new-tag" size="small" @click="showInputObj(index,index2)" round>添加标签
          </el-button>
        </div>

      </div>
    </div>


  </div>

</template>

<script>
  var _this;
  export default {

    data() {
      return {

        star_point: [],

        tableData: [],

        // 添加标签
        inputVisible: [{
          visible: false
        }, {
          visible: false
        }, {
          visible: false
        }, {
          visible: false
        }, {
          visible: false
        }],
        input_adminVisible: {
          consumer: {
            order_cancel: false,
            order_finish:false,
            legwork_order_cancel:false
          },
          driver: {
            order_cancel: false,
            leave_reason:false,
            freeze_reason:false,
            comment_consumer:false
          },
          admin: {
            visit: false,
            order_cancel: false,
            legwork_order_cancel:false
          },
        },
        inputValue: '',



        search_data: {
          status: '',
        },
        search_rules: {
          status: {
            placeholder: '请选择状态',
            rules: {
              required: false,
              message: '状态未选择',
              regulation: 'special',
              rulesData: '0|1'
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.star_point.length = 0;







        _this.labelLists();



    },

    methods: {
      searchLabelLists() {

        _this.labelLists();

      },
      //禁用和启用标签
      toSwitch(code, status) {
        console.log(code);
        console.log(status);
        var tagStatus = '';
        if (status == '1') {
          tagStatus = '0'
        } else if (status == '0') {
          tagStatus = '1'
        }
        _this.$post(
          "/label/executeStatusSubmit", {
            label_code: code,
            status: tagStatus
          }
        ).then(res => {

          _this.labelLists();


        }).catch((err) => {

        })

      },
      showInputObj(index, index2) {
        console.log(_this.inputVisible);

        for (let i = 0; i < _this.inputVisible.length; i++) {

          _this.inputVisible[i].visible = false;

        }
        for (const key in this.input_adminVisible) {
          for (const i in this.input_adminVisible[key]) {
            this.input_adminVisible[key][i] = false;
          }
        }

        _this.input_adminVisible[index][index2] = true;

      },

      // 添加标签
      showInput(index) {
        console.log(index);
        for (let i = 0; i < _this.inputVisible.length; i++) {

          _this.inputVisible[i].visible = false;

        }
        for (const key in this.input_adminVisible) {
          for (const i in this.input_adminVisible[key]) {
            this.input_adminVisible[key][i] = false;
          }
        }


        _this.inputVisible[index - 1].visible = true;




        this.$nextTick(_ => {

          // this.$refs.saveTagInput.$refs.input.focus();

        });
      },


      handleInputConfirm(port, star_point, label_mode) {
        let inputValue = this.inputValue;
        console.log(star_point);

        if (inputValue) {

          _this.$post(
            "/label/addLabelSubmit", {
              port: port,
              star_point: star_point,
              label: _this.inputValue,
              label_mode: label_mode,
              status: '1'
            }
          ).then(res => {

            _this.labelLists();

          }).catch((err) => {

          })
        }


        for (let i = 0; i < _this.inputVisible.length; i++) {

          _this.inputVisible[i].visible = false;

        }
        for (const key in this.input_adminVisible) {
          for (const i in this.input_adminVisible[key]) {
            this.input_adminVisible[key][i] = false;
          }
        }

        this.inputValue = '';
      },




      // 删除标签
      handleClose(code) {
        console.log(code);

        _this.$post(
          "/label/deleteLabelSubmit", {
            label_code: code
          }
        ).then(res => {

          _this.labelLists();

        }).catch((err) => {

        })

        // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },



      // 选择状态下拉
      statusChange(val) {
        console.log(val);
        _this.search_data.status = val;

      },


      // 搜索标签列表
      labelLists() {

        _this.$post(
            "/label/labelLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;


            for (const key in _this.tableData) {

              for (const i in _this.tableData[key]) {


                if (_this.tableData[key][i].type == 'star') {


                  for (const j in _this.tableData[key][i].label) {
                    _this.star_point.push(Number(j));
                  }

                }


              }

            }

          }).catch((err) => {

          })



      },


    }
  };
</script>

<style scoped>
  .container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
  }

  .title {
    background-color: #eee;
    height: 30px;
    line-height: 30px;
    display: flex;
  }

  .title span {
    display: inline-block;
    width: 10px;
    height: 30px;
    background-color: #409EFF;
    margin-right: 20px;
  }

  .title h2 {
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    color: #000;
  }

  p {
    font-size: 14px;
  }

  .el-tag {
    margin: 0 5px;
  }

  .el-rate {
    height: 40px;
  }

  .el-tag+.el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .el-tag.el-tag--small.el-tag--light {
    padding: 5px;
    box-sizing: border-box;
    height: 26px;
    line-height: 16px;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
  }

  .el-button.button-new-tag.el-button--default.el-button--small.is-round {
    color: #999;
  }
</style>
